import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { Box } from "@mui/material";
import QuestionItemWrapper from "./QuestionItemWrapper";
import { QuestionListStyle } from "../question.style";
import { useVirtualizer } from "@tanstack/react-virtual";
import React, { useRef } from "react";
import {
  selectSelectedQuestionIds,
  toggleQuestionSelection,
} from "../../../Redux/reducers/questionSlice";

const DropAreaNew: React.FC = () => {
  const parentRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();

  const questions = useAppSelector((state) => state.question.questions);
  const selectedIds = useAppSelector(selectSelectedQuestionIds);

  const virtualizer = useVirtualizer({
    count: questions.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 45,
  });

  const items = virtualizer.getVirtualItems();

  return (
    <Box sx={QuestionListStyle} ref={parentRef}>
      <div
        style={{
          height: virtualizer.getTotalSize(),
          width: "100%",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            transform: `translateY(${items[0]?.start ?? 0}px)`,
          }}
        >
          {items.map((virtualRow) => {
            const question = questions[virtualRow.index];
            return (
              <div
                key={virtualRow.key}
                data-index={virtualRow.index}
                ref={virtualizer.measureElement}
              >
                <QuestionItemWrapper
                  key={question.id}
                  index={virtualRow.index}
                  question={question}
                  selected={selectedIds.includes(question.id)}
                  onToggleSelect={(id) =>
                    dispatch(toggleQuestionSelection(id))
                  }
                />
              </div>
            );
          })}
        </div>
      </div>
    </Box>
  );
};

export default DropAreaNew;
